import { FC } from 'react';
import { Card } from '../../../ui';
import { BalanceChart } from './BalanceChart';
import { styled } from '@mui/material';

export const BalanceAssessment: FC = () => {
  return (
    <Card title='Standing Assessment'>
      <Root>
        <ChartTitle>Cone of Balance (cm)</ChartTitle>
        <BalanceChart />
      </Root>
    </Card>
  );
};

const Root = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
`;

const ChartTitle = styled('div')`
  font-weight: 600;
  font-size: 16px;
`;
